import styled from "styled-components";
import { Button } from "../../../../styles/button";
import { size } from "../../../../utils/styles";

export const OrdersTableHeaderButton = styled(Button)`
  @media screen and (max-width: ${size.mobile}) {
    padding: 7px 11px;
  }
`;
